import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import { DataCacheProvider } from './contexts/DataCacheContext';
import Overview from './pages/Overview';
import StudentManagement from './pages/StudentManagement';
import BatchManagement from './pages/BatchManagement';
import CourseManagement from './pages/CourseManagement';
import TeacherManagement from './pages/TeacherManagement';
import Login from './pages/Login';
import MaterialManagement from './pages/MaterialManagement';
import Profile from './pages/Profile';
import apiService from './services/api';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [userProfile, setUserProfile] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    // Check if admin is logged in and verify token
    const checkAuth = async () => {
      const token = localStorage.getItem('authToken');
      const storedProfile = localStorage.getItem('userProfile');
      
      if (token && storedProfile) {
        try {
          // Verify token is still valid
          const profile = await apiService.getUserProfile();
          if (profile.role === 'admin') {
            setUserProfile(profile);
            setIsAuthenticated(true);
          } else {
            // Not an admin, clear auth
            apiService.clearAuthToken();
            localStorage.removeItem('userProfile');
          }
        } catch (error) {
          // Token invalid, clear auth
          apiService.clearAuthToken();
          localStorage.removeItem('userProfile');
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const handleLogin = (profile) => {
    setUserProfile(profile);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    apiService.logout();
    setIsAuthenticated(false);
    setUserProfile(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="large" message="Loading..." />
      </div>
    );
  }

  return (
    <Router>
      {!isAuthenticated ? (
        <Login onLogin={handleLogin} />
      ) : (
        <DataCacheProvider>
          <Layout userProfile={userProfile} onLogout={handleLogout}>
            <div className="flex">
              <main className="flex-1 overflow-auto">
                <div className="p-6">
                  <Routes>
                  <Route path="/" element={<Navigate to="/overview" replace />} />
                  <Route path="/overview" element={<Overview />} />
                  <Route path="/students" element={<StudentManagement />} />
                  <Route path="/courses" element={<CourseManagement />} />
                  <Route path="/materials" element={<MaterialManagement />} />
                  <Route path="/batches" element={<BatchManagement />} />
                  <Route path="/teachers" element={<TeacherManagement />} />
                  <Route path="/profile" element={<Profile />} />
                  {/* Catch any other routes and redirect to overview when authenticated */}
                  <Route path="*" element={<Navigate to="/overview" replace />} />
                  </Routes>
                </div>
              </main>
            </div>
          </Layout>
        </DataCacheProvider>
      )}
    </Router>
  );
}

export default App;
